"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styledEntities_1 = require("./styledEntities");
const Switch = ({ isEnabled, onToggle, disabled, activeColor, inactiveColor, onHandleColor, offHandleColor, bgStyle, }) => (react_1.default.createElement("div", null,
    react_1.default.createElement(styledEntities_1.Background, { onClick: () => (disabled ? () => { } : onToggle()), isEnabled: isEnabled, activeColor: activeColor, inactiveColor: inactiveColor, style: bgStyle },
        react_1.default.createElement(styledEntities_1.Handle, { isEnabled: isEnabled, activeColor: onHandleColor, inactiveColor: offHandleColor }))));
exports.default = Switch;
//# sourceMappingURL=Switch.js.map